import { Button, Dialog } from '@mui/material';
import { FC } from 'react';
import { IChangeCoverImageModal } from '../../../interfaces/components/modal.interface';

const ChangeCoverImageModal: FC<IChangeCoverImageModal> = ({
  open,
  onClose,
  confirmCallback,
}) => {
  const handleConfirm = () => {
    onClose();
    confirmCallback();
  };
  return (
    <Dialog onClose={onClose} open={open}>
      <div className="flex flex-col gap-y-6 p-4">
        <h1 className="font-bold text-xl">Đổi ảnh bìa</h1>
        <p>Kích thước ảnh bìa tối ưu là 1200 x 480</p>

        <Button
          style={{ textTransform: 'none' }}
          className="!text-white !bg-primary_lighter hover:!bg-primary_lighter"
          onClick={handleConfirm}
        >
          Chọn ảnh từ thiết bị
        </Button>
      </div>
    </Dialog>
  );
};

export default ChangeCoverImageModal;
